import React, { PureComponent } from 'react';
import { Bar } from 'react-chartjs-2';

const data =
{
    labels: [],
    datasets: [
        {
            label: 'Income',
            backgroundColor: ['#a3ff8f', '#ff691f', '#00cfd6', '#52bdff', '#a3ff8f', '#ff691f', '#00cfd6', '#52bdff', '#a3ff8f', '#ff691f', '#00cfd6', '#52bdff'],
            borderColor: 'white',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: []
        }
    ]
}

class AverageEventType extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: data
        }
    }

    createData = (events) => {
        function reduceFunction(total, sum) {
            return total + sum;
        }

        let types = []; //changed from teams
        events.forEach(event => { types.push(event.type) })
        let uniqueTypes = Array.from(new Set(types));
        data.labels = uniqueTypes;
        data.datasets[0].data = [];

        data.labels.forEach((type, i) => {
            let tempArr = [];
            let typeNumber = 0;
            events.forEach(event => {
                if (type === event.type) {
                    tempArr.push(Number(event.earned));
                    typeNumber++;
                }
            })
            if (tempArr.length > 0) {
                data.datasets[0].data[i] = tempArr.reduce(reduceFunction, 0) / typeNumber;
            } else data.datasets[0].data[i] = 0;
        })
    }

    render() {
        const { events } = this.props;
        this.createData(events)
        return (
            <div className='w-100 mt3 bb'>
                <h3 className='tc'>Average by Event Type </h3>
                <Bar
                    height={125}
                    data={this.state.data}
                    redraw={true}
                    options={{
                        scales: {
                            yAxes: [{
                                ticks: {
                                    min: 0
                                }
                            }]
                        }
                    }}
                />
            </div>
        )
    }
}

export default AverageEventType;